export default function() {
  return {
    namespaced: true,
    state: {
      contentHost: '',
      mapVisitorFlowMode: false,
      freeze: false,
      routing: false,
      isMobile: false,
      isIOS: false,
      isAndroid: false,
      isMobileView: false,
      mobileHeader: false,
      isMapHide: false,
      showMapOnMobile: false,
      pageLoadingPlaceholder: null,
      blackAndWhite: false,
      disableMapbox: false,
      mqls: {}
    },
    mutations: {
      UPDATE_CONTENT_HOST(state, { host }) {
        state.contentHost = host;
      },
      UPDATE_MAP_VISITOR_FLOW_MODE(state, { mapVisitorFlowMode }) {
        state.mapVisitorFlowMode = !!mapVisitorFlowMode;
      },
      UPDATE_BLACK_AND_WHITE(state, { blackAndWhite }) {
        state.blackAndWhite = !!blackAndWhite;
      },
      UPDATE_DISABLE_MAPBOX(state, { disableMapbox }) {
        state.disableMapbox = !!disableMapbox;
      },
      UPDATE_FREEZE(state, { freeze }) {
        state.freeze = !!freeze;
      },
      UPDATE_ROUTING(state, { routing }) {
        state.routing = !!routing;
      },
      UPDATE_MOBILE_HEADER(state, { show }) {
        state.mobileHeader = !!show;
      },
      UPDATE_IS_MOBILE(state, { isMobile }) {
        state.isMobile = !!isMobile;
      },
      IS_IOS(state) {
        state.isIOS = true;
      },
      IS_ANDROID(state) {
        state.isAndroid = true;
      },
      UPDATE_IS_MOBILE_VIEW(state, { isMobileView }) {
        state.isMobileView = !!isMobileView;
      },
      UPDATE_IS_MAP_HIDE(state, { isMapHide }) {
        state.isMapHide = !!isMapHide;
      },
      UPDATE_SHOW_MAP_ON_MOBILE(state, { show }) {
        state.showMapOnMobile = !!show;
      },
      UPDATE_PAGE_LOADING_PLACEHOLDER(state, { component }) {
        state.pageLoadingPlaceholder = component;
      },
      ADD_MQL(state, { key, mql })  {
        if (!state.mqls[key]) {
          state.mqls[key] = mql
        }
      }
    },
    actions: {
      SET_PAGE_LOADING_PLACEHOLDER({ commit }, { component}) {
        commit('UPDATE_PAGE_LOADING_PLACEHOLDER', { component });
      },
      START_ROUTING({ commit }) {
        commit('UPDATE_ROUTING', { routing: true });
      },
      FINISH_ROUTING({ commit }) {
        commit('UPDATE_ROUTING', { routing: false });
      },
      IS_IOS({ commit }) {
        commit('IS_IOS',);
        commit('UPDATE_IS_MOBILE', { isMobile: true });
      },
      IS_ANDROID({ commit }) {
        commit('IS_ANDROID');
        commit('UPDATE_IS_MOBILE', { isMobile: true });
      },
      UPDATE_IS_MOBILE({ commit }, { isMobile }) {
        commit('UPDATE_IS_MOBILE', { isMobile });
      },
      UPDATE_IS_MOBILE_VIEW({ commit }, { isMobileView }) {
        commit('UPDATE_IS_MOBILE_VIEW', { isMobileView });
        if (!isMobileView) {
          commit('UPDATE_MOBILE_HEADER', { show: false });
        }
      },
      ACTIVE_MOBILE_HEADER({ commit }) {
        commit('UPDATE_MOBILE_HEADER', { show: true });
      },
      DISMISS_MOBILE_HEADER({ commit }) {
        commit('UPDATE_MOBILE_HEADER', { show: false });
      },
      UPDATE_IS_MAP_HIDE({ commit }, { isMapHide }) {
        commit('UPDATE_IS_MAP_HIDE', { isMapHide });
        if (!isMapHide) {
          commit('UPDATE_SHOW_MAP_ON_MOBILE', { show: false});
        }
      },
      ACTIVE_MAP_ON_MOBILE({ commit }) {
        commit('UPDATE_SHOW_MAP_ON_MOBILE', { show: true});
      },
      DISMISS_MAP_ON_MOBILE({ commit }) {
        commit('UPDATE_SHOW_MAP_ON_MOBILE', { show: false});
      },
      FREEZE_BODY({ commit }) {
        commit('UPDATE_FREEZE', { freeze: true});
      },
      DISMISS_FREEZE_BODY({ commit }) {
        commit('UPDATE_FREEZE', { freeze: false});
      },
      UPDATE_MAP_VISITOR_FLOW_MODE({ commit }, { mapVisitorFlowMode }) {
        commit('UPDATE_MAP_VISITOR_FLOW_MODE', { mapVisitorFlowMode })
      },
      UPDATE_BLACK_AND_WHITE({ commit }, { blackAndWhite }) {
        commit('UPDATE_BLACK_AND_WHITE', { blackAndWhite })
      },
      UPDATE_DISABLE_MAPBOX({ commit }, { disableMapbox }) {
        commit('UPDATE_DISABLE_MAPBOX', { disableMapbox })
      },
      ADD_MQL({ state, commit }, { key, mql }) {
        if (!state.mqls[key]) {
          commit('ADD_MQL', { key, mql});
        }
      },
      UPDATE_CONTENT_HOST({ commit }, { host }) {
        commit('UPDATE_CONTENT_HOST', { host });
      },
    },
    getters: {
      getMQL: (state) => (key) => {
        return state.mqls[key] || null
      },
    }
  }
}
